export class ExpiredPasswordResetCodeError extends Error {
  constructor(code: string) {
    super(`Expired password reset code: ${code}`);
  }
}
